import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  commonData: {

  }
};
const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCommonData: (state, action) => {
      console.log("Updating common data:", action.payload);
    //   state.commonData = action.payload;
       // Merge the payload with the existing commonData
      state.commonData = {
        ...state.commonData,
        ...action.payload, // partial updates like { menuList: [...] }
      };
    },
    clearCommonData: (state) => {
      state.commonData = {};
        console.log("Common data cleared");
    },
  },
});

export const { setCommonData, clearCommonData } = commonSlice.actions;
export default commonSlice.reducer;